<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-left">
                        <h2>{{tituloCrud}}</h2>
                    </div>
                </div>
            </div>

            <div>
                <form [formGroup]="formularioMotivoCancelamento" (ngSubmit)="onSubmit()"
                    (keydown.enter)="$event.preventDefault()">
                    <div class="form-group">
                        <mat-divider fxFlex="1 0"></mat-divider>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-12 col-md-12 col-sm-12 col-12">
                            <mat-label>Descrição</mat-label>
                            <input matInput value="Descrição" class="form-control" id="descricao" required trim="blur"
                                name="descricao" formControlName="descricao" maxlength="60" upperCase>
                            <mat-error *ngIf="formularioMotivoCancelamento.controls.descricao.hasError('required')">
                                O campo Descrição é obrigatório.
                            </mat-error>
                            <mat-error *ngIf="formularioMotivoCancelamento.controls.descricao.hasError('minlength')">
                                O campo Descrição precisa conter mais do que 2 caracteres.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="menu-formulario">
                        <div class="menu-formulario-botoes margin-right-10" *ngIf="!isInfo">
                            <button mat-mini-fab color="success" type="submit" matTooltip="Salvar"
                                [disabled]="!formularioMotivoCancelamento.valid">
                                <mat-icon>save</mat-icon>
                            </button>
                        </div>
                        <div class="menu-formulario-botoes">
                            <botao-voltar></botao-voltar>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>